import React from "react";
import AddCommentModal from "./AddCommentModal";
import AssetOwnershipProfileModal from "./AssetOwnershipProfileModal";
import BankingCommentsModal from "./BankingCommentsModal";
import CollectionBreakdownModal from "./CollectionBreakdownModal";
import CollectionModal from "./CollectionModal";
import ConfirmModal from "./ConfirmModal";
import CountDetailsModal from "./CountDetailsModal";
import EnterPasswordModal from "./EnterPasswordModal";
import FloatLevelSettingsModal from "./FloatLevelSettingsModal";
import InstallHistoryModal from "./InstallHistoryModal";
import LiveFloorViewDetailsModal from "./LiveFloorViewDetailsModal";
import NewProfileModal from "./NewProfileModal";
import PromoAnalysisDetailsModal from "./PromoAnalysisDetailsModal";
import PromoAnalysisModal from "./PromoAnalysisModal";
import RevenueModal from "./RevenueModal";
import SiteDetailsModal from "./SiteDetailsModal";
import SuccessModal from "./SuccessModal";
import VarianceHistoryDetailsModal from "./VarianceHistoryDetailsModal";
import ViewCommentsModal from "./ViewCommentsModal";
import DownloadReportModal from "./DownloadReportModal.js";
import EditMachineCountModal from "./EditMachineCountModal.js";
import ProcessPeriodModal from "./ProcessPeriodModal.js";

// Common Modals
import AlertModal from "@common/components/modals/AlertModal";
import LoadingModal from "@common/components/modals/LoadingModal";
import CommonConfirmModal from "@common/components/modals/ConfirmModal";
import OfficerFormModal from "@common/components/modals/OfficerFormModal";
import ImageModal from "@common/components/modals/ImageModal";
import SessionModal from "@common/components/modals/SessionModal.js";
import MachineSessionModal from "@common/components/modals/MachineSessionModal";
import CustomerReviewFormModal from "@common/components/modals/CustomerReviewFormModal";
import QrCodeModal from "@common/components/modals/QrCodeModal.js";
import IdentityFormModal from "@common/components/modals/IdentityFormModal.js";
import AuthorisationModal from "@common/components/modals/AuthorisationModal.js";
import SiteAllocatedModal from "./SiteAllocatedModal.js";
import DateRangeModal from "./DateRangeModal.js";
import ConfirmInputModal from "./ConfirmInputModal.js";
import StatusChangeModal from "@common/components/modals/StatusChangeModal.js";

const ModalContainer = () => {
  return (
    <>
      <AddCommentModal />
      <AssetOwnershipProfileModal />
      <BankingCommentsModal />
      <CollectionBreakdownModal />
      <CollectionModal />
      <ConfirmModal />
      <ConfirmInputModal />
      <CountDetailsModal />
      <DownloadReportModal />
      <EnterPasswordModal />
      <FloatLevelSettingsModal />
      <InstallHistoryModal />
      <LiveFloorViewDetailsModal />
      <NewProfileModal />
      <ProcessPeriodModal />
      <PromoAnalysisDetailsModal />
      <PromoAnalysisModal />
      <OfficerFormModal />
      <RevenueModal />
      <SiteDetailsModal />
      <SuccessModal />
      <VarianceHistoryDetailsModal />
      <ViewCommentsModal />
      <EditMachineCountModal />
      <AlertModal />
      <ImageModal />
      <CommonConfirmModal />
      <SessionModal />
      <MachineSessionModal />
      <QrCodeModal />
      <CustomerReviewFormModal />
      <IdentityFormModal />
      <LoadingModal />
      <AuthorisationModal />
      <SiteAllocatedModal />
      <DateRangeModal />
      <StatusChangeModal />
    </>
  );
};

export default ModalContainer;
